import { render } from "./AppTitleX.vue?vue&type=template&id=19f62fa9&scoped=true"
import script from "./AppTitleX.vue?vue&type=script&lang=js"
export * from "./AppTitleX.vue?vue&type=script&lang=js"

import "./AppTitleX.vue?vue&type=style&index=0&id=19f62fa9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f62fa9"]])

export default __exports__